import React, { useEffect, useState } from "react";
import { getMarketData } from "../services/api";
import { motion } from "framer-motion";

const CryptoTable = () => {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getMarketData();
      setCoins(data);
    };
    fetchData();
  }, []);

  return (
    <motion.div
      className="min-h-screen bg-gradient-to-br from-pink-800 via-violet-900 to-pink-800 px-4 sm:px-6 lg:px-8 py-10 text-pink-100"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      {/* Logo and Header */}
      <motion.div
        className="flex flex-col sm:flex-row justify-center items-center gap-3 mb-8 sm:mb-10"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 100, delay: 0.5 }}
      >
        <div className="w-10 h-10 rounded-full bg-purple-800 shadow-lg flex items-center justify-center">
          <span className="text-pink-400 font-extrabold text-xl">₿</span>
        </div>
        <h1 className="text-2xl text-purple-200 sm:text-3xl md:text-4xl font-bold tracking-wide drop-shadow-md text-center">
          Beu's <span className="text-purple-400">Crypto</span> Dashboard
        </h1>
      </motion.div>

      {/* Table */}
      <div className="overflow-x-auto backdrop-blur-md bg-purple-500/20 rounded-xl shadow-2xl border border-purple-300/20 max-w-full mx-auto">
        <table className="w-full text-sm text-left text-gray-200">
          <thead className="bg-purple-800/50 text-xs uppercase text-pink-200 tracking-wider">
            <tr>
              <th scope="col" className="px-4 py-3 sm:px-6">
                #
              </th>
              <th scope="col" className="px-4 py-3 sm:px-6">
                Name
              </th>
              <th scope="col" className="px-4 py-3 sm:px-6 text-right hidden sm:table-cell">
                Price
              </th>
              <th scope="col" className="px-4 py-3 sm:px-6 text-right hidden md:table-cell">
                Market Cap
              </th>
              <th scope="col" className="px-4 py-3 sm:px-6 text-right">
                24h Change
              </th>
            </tr>
          </thead>
          <tbody>
            {coins.map((coin, index) => (

              <motion.tr
                key={coin.id}
                className="bg-purple-800/10 border-b border-purple-300/20 hover:bg-purple-700/20 transition-all"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: index * 0.06 }}
              >
                <td className="px-4 py-4 sm:px-6 font-bold">{index + 1}</td>
                <td className="px-4 py-4 sm:px-6">
                  <div className="flex items-center gap-2">
                    <img src={coin.image} alt={coin.name} className="w-5 h-5" />
                    <div>
                      <span>{coin.name}</span>{" "}
                      <span className="text-gray-500">({coin.symbol.toUpperCase()})</span>
                      <div className="sm:hidden text-sm">
                        <div>${coin.current_price.toLocaleString()}</div>
                        <div className="md:hidden">${coin.market_cap.toLocaleString()}</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-4 sm:px-6 text-right hidden sm:table-cell">
                  ${coin.current_price.toLocaleString()}
                </td>
                <td className="px-4 py-4 sm:px-6 text-right hidden md:table-cell">
                  ${coin.market_cap.toLocaleString()}
                </td>
                <td
                  className={`px-4 py-4 sm:px-6 text-right font-bold ${
                    coin.price_change_percentage_24h > 0
                      ? "text-green-400"
                      : "text-red-400"
                  }`}
                >
                  {coin.price_change_percentage_24h.toFixed(2)}%
                </td>
              </motion.tr>
            ))}
          </tbody>
        </table>
      </div>
    </motion.div>
  );
};

export default CryptoTable;